import { IAccount } from "./IAccount";

export interface AuthenticationResult {
    accessToken: string | null;
    account: IAccount | null;
    tenantId: string | null;
    success: boolean;
    error?: string;
}

export interface AuthConfig {
    clientId: string;
    authority: string;
    redirectUri: string;
    scopes: string[];
    postLogoutRedirectUri?: string;
}

export enum AuthenticationProvider {
    MSAL = "msal",
    AUTH0 = "auth0"
}

export interface IAuthenticationProvider {
    /**
     * Initialize the authentication provider
     */
    initialize(): Promise<void>;

    /**
     * Get current access token silently
     */
    getTokenSilent(forceRefresh?: boolean): Promise<AuthenticationResult>;

    /**
     * Perform interactive login
     */
    login(loginState?: string): Promise<void>;

    /**
     * Force login with account selection
     */
    forceLogin(): Promise<void>;

    /**
     * Logout user
     */
    logout(): Promise<void>;

    /**
     * Get current account information
     */
    getAccount(): IAccount | null;

    /**
     * Get current access token
     */
    getAccessToken(): string | null;

    /**
     * Get tenant ID
     */
    getTenantId(): string | null;

    /**
     * Get provider type
     */
    getProviderType(): AuthenticationProvider;



    /**
     * Handle redirect callback (for redirect-based auth flows)
     */
    handleRedirectCallback?: () => Promise<void>;
}
